/* src/app/modules_v2/finance/reconciliation/old-import-bank-conciliaton/old-bankaccount.component.css */
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
/*# sourceMappingURL=old-bankaccount.component.css.map */
